import { useState } from 'react'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { InputText } from '#app/components/ui/input-text'

interface AseguradoData {
	nombreAsegurado: string
	direccion: string
	telefono: string
	email: string
}

interface RCContratistasAseguradoScreenProps {
	onNext: (data: AseguradoData) => void
	onBack: () => void
	data?: Partial<AseguradoData>
}

export function RCContratistasAseguradoScreen({
	onNext,
	onBack,
	data,
}: RCContratistasAseguradoScreenProps) {
	const [formData, setFormData] = useState<AseguradoData>({
		nombreAsegurado: data?.nombreAsegurado || '',
		direccion: data?.direccion || '',
		telefono: data?.telefono || '',
		email: data?.email || '',
	})

	const [errors, setErrors] = useState<
		Partial<Record<keyof AseguradoData, string>>
	>({})

	const validateForm = (): boolean => {
		const newErrors: Partial<Record<keyof AseguradoData, string>> = {}

		if (!formData.nombreAsegurado.trim()) {
			newErrors.nombreAsegurado = 'El nombre del asegurado es requerido'
		}
		if (!formData.direccion.trim()) {
			newErrors.direccion = 'La dirección es requerida'
		}
		if (!formData.telefono.trim()) {
			newErrors.telefono = 'El teléfono es requerido'
		}
		if (!formData.email.trim()) {
			newErrors.email = 'El email es requerido'
		} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
			newErrors.email = 'El email no es válido'
		}

		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleSubmit = () => {
		if (validateForm()) {
			onNext(formData)
		}
	}

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col items-center gap-6">
					<h2 className="font-parkinsans text-center text-2xl leading-8 font-medium text-blue-800">
						Datos del Asegurado
					</h2>
					<p className="text-center text-sm text-neutral-600">
						Ingresá los datos del contratista a asegurar
					</p>

					<div className="flex w-full flex-col gap-4">
						<InputText
							label="Nombre del Asegurado / Razón Social"
							labelPosition="internal"
							size="l"
							placeholder="Nombre completo o razón social"
							value={formData.nombreAsegurado}
							onChange={(e) =>
								setFormData({ ...formData, nombreAsegurado: e.target.value })
							}
							errorText={errors.nombreAsegurado}
						/>

						<InputText
							label="Dirección"
							labelPosition="internal"
							size="l"
							placeholder="Dirección completa"
							value={formData.direccion}
							onChange={(e) =>
								setFormData({ ...formData, direccion: e.target.value })
							}
							errorText={errors.direccion}
						/>

						<InputText
							label="Teléfono"
							labelPosition="internal"
							size="l"
							placeholder="11 1234-5678"
							value={formData.telefono}
							onChange={(e) =>
								setFormData({ ...formData, telefono: e.target.value })
							}
							errorText={errors.telefono}
						/>

						<InputText
							label="Email"
							labelPosition="internal"
							size="l"
							placeholder="correo@empresa.com"
							type="email"
							value={formData.email}
							onChange={(e) =>
								setFormData({ ...formData, email: e.target.value })
							}
							errorText={errors.email}
						/>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="ghost"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Atrás
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={handleSubmit}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Siguiente
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
